module.exports = __webpack_public_path__ + "img/twitter_hover.2ef61b80.svg";